import React from 'react'
import { t } from '@lingui/core/macro'
import { formatNumber } from '../../utils/formatters'
import { TransactionResult } from '../../types/TransactionResult'
import styles from './OrderInfo.module.css'

interface OrderInfoProps {
    transaction: TransactionResult
    amount?: number
    orderId?: string
    description?: string
}

const OrderInfo = ({ transaction, amount, orderId, description }: OrderInfoProps) => (
    <div className={styles.orderInfo}>
        <div className={styles.amountSection}>
            <span className={styles.amountLabel}>{t`Сумма к оплате`}</span>
            <div className={styles.amount}>
                {formatNumber((amount ?? transaction.amount) / 100, 2)}
                <span className={styles.currency}>{transaction.currency.toUpperCase()}</span>
            </div>
        </div>
        {orderId && (
            <div className={styles.orderDetails}>
                <span className={styles.orderLabel}>{t`Заказ #${orderId}`}</span>
            </div>
        )}
        {description && (
            <div className={styles.orderDetails}>
                <span className={styles.orderLabel}>{description}</span>
            </div>
        )}
    </div>
)

export default OrderInfo
